import { useNavigate } from "infrastructure/router";
import { BooleanSwitchValue } from "consts/general";
import { WebRoutes } from "consts/enpoints/web";
import { delay } from "util/support";
import { putOnboardingsApplications } from "features/ecommerce/api";
import useActions from "features/auth/useActions";
import type { Merchant as MerchantType } from "features/ecommerce/types";
import { Merchant } from "ui/forms/ECommerce";
import { useOnboardingForm } from "ui/organizms/ECommerce/Onboarding/common";
import { useOnboardingApplication } from "../../hooks";

export const useComplete = () => {
    const navigate = useNavigate();
    const { getUser } = useActions();
    const { getApplicationModel } = useOnboardingApplication();

    const withValues = useOnboardingForm({
        save: putOnboardingsApplications<MerchantType.OnboardingApplication>,
        onSuccess: () => {
            const [request] = getUser();

            return request
                .then(() => delay(100))
                .then(() => navigate(WebRoutes.Root));
        },
        route: WebRoutes.Onboarding.Merchant,
        getApplicationModel
    });

    const formProps: Merchant.CompleteOnboarding.OnboardingCompleteOnboaringForm = {
        bootstrapData: {},
        initialValues: Merchant.CompleteOnboarding.getInitialValues({}),
        isBootstrapDataLoading: false,
        onSaveOrCreate: (_, formHelpers) => withValues({
            hasAgreedTermsConditions: BooleanSwitchValue.On
        }, formHelpers)
    };

    return {
        ...formProps,
        ...Merchant.CompleteOnboarding.useForm(formProps)
    };
};

export default useComplete;
